import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Footer = () => (
  <footer className="w-full border-t border-gray-100 dark:border-purple-900 bg-white dark:bg-purple-950 transition-colors duration-300">
    <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row justify-between items-center gap-4">
      <div className="flex items-center space-x-2">
        <SafeIcon icon={FiIcons.FiFeather} className="text-amber-500 text-xl" />
        <span className="font-serif font-bold text-gray-900 dark:text-purple-200 text-lg">Weaver</span>
        <span className="text-gray-900 text-sm hidden sm:inline dark:text-purple-400">· Powered by Big Hook Media Inc.</span>
      </div>

      <nav className="flex items-center space-x-6">
        {[
          { path: '/privacy', label: 'Privacy' },
          { path: '/terms', label: 'Terms' },
          { path: '/support', label: 'Support' },
        ].map(({ path, label }) => (
          <Link
            key={path}
            to={path}
            className="text-sm font-medium text-gray-900 dark:text-purple-400 hover:text-amber-600 dark:hover:text-amber-400 transition-colors"
          >
            {label}
          </Link>
        ))}
      </nav>

      <p className="text-xs text-gray-900 dark:text-purple-600 sm:hidden">
        Powered by Big Hook Media Inc.
      </p>
    </div>
  </footer>
);

export default Footer;